import * as am5xy from '@amcharts/amcharts5/xy';
import * as am5 from '@amcharts/amcharts5';

export class AuAmchartHelper {
	static createChart(root) {
		return root.container.children.push(
			am5xy.XYChart.new(root, {
				panY: false,
				wheelY: 'zoomX',
				layout: root.verticalLayout,
				maxTooltipDistance: 0,
			})
		);
	}

	static createXAxis(root, chart, _data) {
		return chart.xAxes.push(
			am5xy.DateAxis.new(root, {
				baseInterval: { timeUnit: 'minute', count: 1 },
				renderer: am5xy.AxisRendererX.new(root, {}),
				tooltip: am5.Tooltip.new(root, {}),
				extraMin: 0.03,
				extraMax: 0.03,
			})
		);
	}

	static createYAxis(root, chart) {
		return chart.yAxes.push(
			am5xy.ValueAxis.new(root, {
				extraTooltipPrecision: 1,
				renderer: am5xy.AxisRendererY.new(root, {}),
			})
		);
	}

	static createSeries(root, chart, xAxis, yAxis) {
		return chart.series.push(
			am5xy.LineSeries.new(root, {
				name: 'Series',
				xAxis: xAxis,
				yAxis: yAxis,
				valueYField: 'value',
				valueXField: 'date',
				tooltip: am5.Tooltip.new(root, {
					labelText: '{valueY}',
				}),
			})
		);
	}

	static createBullet(root, series) {
		return am5.Bullet.new(root, {
			sprite: am5.Circle.new(root, {
				radius: 5,
				fill: series.get('fill'),
			}),
		});
	}

	static createRangeLine(
		yAxis,
		settings: {
			value: number;
			color: number;
			label: string;
			strokeWidth: number;
			strokeDasharray: number[];
		}
	) {
		const rangeLine = yAxis.createAxisRange(
			yAxis.makeDataItem({ value: settings.value })
		);

		rangeLine.get('grid').setAll({
			stroke: am5.color(settings.color), // Color of the line
			strokeWidth: settings.strokeWidth, // Thickness of the line
			strokeDasharray: settings.strokeDasharray, // Optional: Makes the line dashed. Remove this line for a solid line.
		});

		rangeLine.get('label').setAll({
			text: settings.label,
			inside: true,
			rotation: 90,
		});

		return rangeLine;
	}

	static setCursor(chart, root, xAxis) {
		chart.set(
			'cursor',
			am5xy.XYCursor.new(root, {
				behavior: 'zoomXY',
				xAxis: xAxis,
			})
		);
	}

	static setTooltipForAxis(root, axis) {
		axis.set(
			'tooltip',
			am5.Tooltip.new(root, {
				themeTags: ['axis'],
			})
		);
	}

	static setTooltipForSeriesBullet(series, template: string) {
		series.set('tooltipHTML', template);
	}
}
